// Globální stav pro přihlašovací modál.
// Dřív byl LoginModal lokální v UserIcon (3 varianty) — teď se vykresluje jednou
// v App.jsx a otevírá se odkudkoli přes show(): UserIcon, ChartLoginPlaceholder,
// ResetPasswordLayout po nastavení hesla, useAuthStore.sessionExpired().
// `notice` = hláška nad formulářem (např. "Platnost přihlášení vypršela"),
// `reason` = proč se modál otevřel ('session_expired' | null).
import { create } from 'zustand'

export const useLoginModalStore = create((set) => ({
  open:   false,
  reason: null,
  notice: null,
  // show se předává i přímo jako onClick handler — pak první argument je event, ne reason.
  show: (reason, notice) => set({
    open:   true,
    reason: typeof reason === 'string' ? reason : null,
    notice: typeof notice === 'string' ? notice : null,
  }),
  hide: () => set({ open: false, reason: null, notice: null }),
}))
